<template>
  <div class="periodic-age-verification-dialog" id="periodic-age-verification-dialog" :class="{ 'fade-in': periodicAgeVerification.shown, 'fade-out': !periodicAgeVerification.shown }">
    <div class="common-dialog-container flex-ends">
      <div class="common-dialog-header">
        <div class="common-dialog-icon">
          <BigIcon class="animate__bounceIn" :loading="true" icon="age-verification" />
        </div>

        <div class="common-dialog-title">{{ $t("receipts.verifyAgeDialogTitle") }}</div>
        <div class="common-dialog-description">{{ $t("receipts.verifyAgeDialogDescription") }}</div>
      </div>

      <div class="common-dialog-footer">
        <div class="common-dialog-button fill">
          <f7-button id="age-verification-confirm-button" @tap="periodicAgeVerification.resolver(true)" large round fill>{{$t("receipts.ageVerifiedConfirm")}}</f7-button>
        </div>
        <div class="common-dialog-button">
          <f7-button id="age-verification-cancel-button" @tap="periodicAgeVerification.resolver(false)" large round>{{$t("receipts.verifyPostpone")}}</f7-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, watch } from "vue"
  import BigIcon from "../BigIcon"

  export default {
    components: { BigIcon },
    setup() {
      const periodicAgeVerification = ref(gui.periodicAgeVerificationData)

      watch(gui.periodicAgeVerificationData, value => {
        periodicAgeVerification.value = value
      })

      return { periodicAgeVerification }
    }
  }
  </script>

  <style lang="scss">
  @import "@/css/variables";

  .periodic-age-verification-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    transform: translateY(100vh);
    background-color: $main-bg-color;
    z-index: 13499;
    transition: .3s;

    &.fade-out {
      .animate__bounceIn {
        animation-name: none !important;
      }
    }

    &.fade-in {
      visibility: visible;
      transform: translateY(0);
    }

    .common-dialog-icon {
      .big-icon-container {
        .big-icon-inner {
          position: relative;
          .big-icon {
            position: absolute;
            right: 8px;
            bottom: 14px;
            img {
              height: 140px;
            }
          }
        }
      }
    }
  }
</style>
